import { connect } from 'dva';
import { useState } from 'react';
import { Toast } from 'antd-mobile';
import { btnBackgroundColor, btnTextColor } from 'utils/theme';
import styles from './index.less';
import payAli from 'images/pay_ali.png';
import payWechat from 'images/pay_wechat.png';
import payUnion from 'images/pay_union.png';
import payCheck from 'images/pay_check.png';
import throttle from '../../utils/throttle';

const Pay = (props) => {
  const { location, global, dispatch } = props;
  const query = (location && location.query) || {};
  const channel = query.channel || global.channel;
  const dragoncode = query.dragoncode || global.dragoncode || localStorage.getItem('dragoncode');
  const phontNum = Number(query.phontNum);
  const POINT_MONEY = global.POINT_MONEY || 160;
  const [payType, setPayType] = useState('06');

  // 支付方式
  const payTypeList = [
    { logo: payWechat, text: '微信支付', type: '06' },
    { logo: payAli, text: '支付宝支付', type: '05' },
    { logo: payUnion, text: '银联支付', type: '49' },
  ];

  // 选择支付方式
  const onSelectPayType = (type) => {
    setPayType(type);
  };

  // 支付
  const onPay = () => {
    throttle(() => {
      Toast.loading();
      dispatch({
        type: 'global/buyPoint',
        payload: {
          dragoncode,
          point: phontNum,
          payType,
        },
        callback: (res) => {
          const payUrl = res.data.payUrl;
          if (payUrl) window.location.href = payUrl;
          if (!payUrl) {
            Toast.hide();
          }
        },
      });
    }, 3000);
  };

  return (
    <div>
      <div className={styles.payMoney}>
        <div className={styles.text}>应付金额</div>
        <div className={styles.money}>￥{phontNum * POINT_MONEY}.0</div>
      </div>
      <ul className={styles.payList}>
        {payTypeList.map((item, index) => (
          <li onClick={() => onSelectPayType(item.type)} key={index}>
            <img src={item.logo} alt="" className={styles.payLogo} />
            <div>{item.text}</div>
            {payType === item.type ? <img src={payCheck} alt="" className={styles.payCheck} /> : ''}
          </li>
        ))}
      </ul>
      <div
        className={styles.payBtn}
        style={{ background: btnBackgroundColor[channel], color: btnTextColor[channel] }}
        onClick={onPay}
      >
        去支付
      </div>
    </div>
  );
};
export default connect(({ global }) => {
  return { global };
})(Pay);
